export const BANK_CODE_SET = [
  { value: '04', label: 'KB국민은행' },
  { value: '23', label: 'SC제일은행' },
  { value: '39', label: '경남은행' },
  { value: '34', label: '광주은행' },
  { value: '03', label: '기업은행' },
  { value: '11', label: '농협' },
  { value: '31', label: '대구은행' },
  { value: '32', label: '부산은행' },
  { value: '02', label: '산업은행' },
  { value: '07', label: '수협' },
  { value: '88', label: '신한은행' },
  { value: '48', label: '신협' },
  { value: '05', label: '외환은행' },
  { value: '20', label: '우리은행' },
  { value: '71', label: '우체국' },
  { value: '37', label: '전북은행' },
  { value: '16', label: '축협' },
  { value: '90', label: '카카오뱅크' },
  { value: '89', label: '케이뱅크' },
  { value: '81', label: '하나은행(서울은행)' },
  { value: '53', label: '한국씨티은행(한미은행)' },
];

export const PAYMENT_METHOD_SET = {
  VIRTUAL_ACCOUNT: '가상계좌',
  CREDIT_CARD: '신용카드',
  KAKAO_PAY: '카카오페이',
  VOUCHER: '상품권',
  NONE: '운영자',
};

export const PAY_DATA = {
  card: 'card',
  vbank: 'vbank',
  kakaopay: 'kakaopay',
  html5_inicis: 'html5_inicis',
};

export const IMP_CODE = 'imp80024443';

export const PRODUCT_NAME = '베이비페이스';

export const isPG = (value) => value === PAY_DATA.kakaopay;

export const getPaymentMethod = ({ pay_method, pg }) =>
  pay_method === PAY_DATA.card
    ? 'CREDIT_CARD'
    : pay_method === PAY_DATA.vbank
    ? 'VIRTUAL_ACCOUNT'
    : pg === PAY_DATA.kakaopay
    ? 'KAKAO_PAY'
    : 'NONE';
